import {React} from 'react';
import Chart from "react-google-charts";
import { useIntl } from "react-intl";

export function ChartCardGoogle(props) {
  const intl = useIntl();
  var labels = {}
  // get keys
  props.data['data'].forEach(function(ddata) {
    if(!ddata["data"][props.ltype]) return null
    var ldata = ddata["data"][props.ltype]['checks'][props.check_type]
    if (!ldata) return null
    Object.keys(ldata).forEach(k => {
      labels[k]=1
    })
  })
  var lKeys = Object.keys(labels)
  var header = [
    {
      type: "date",
      label: "Date"
    },
  ]
  lKeys.forEach(k => {
    header.push({
      type: "number",
      label: intl.formatMessage({ id: "domain." + k }),
    })
  })
  var data1 = [header]
  var data2 = [header]
  props.data['data'].forEach(function(ddata) {
    if(!ddata["data"][props.ltype]) return null
    var ldata = ddata["data"][props.ltype]['checks'][props.check_type]
    if (!ldata) return null
    var res = [new Date(ddata["date"])]
    var res2 = [new Date(ddata["date"])]
    lKeys.forEach(k => {
        res.push(ldata[k])
        res2.push(ldata[k] / ddata["data"][props.ltype]['domains'] * 100)
    })
    data1.push(res)
    data2.push(res2)
  })
  return (
    <div>
        <Chart
            chartType="AnnotationChart"
            data={data1}
            width="100%"
            height="400px"
            legendToggle
          />
    <Chart
            chartType="AnnotationChart"
            data={data2}
            width="100%"
            height="400px"
            legendToggle
          />
      </div>
    )
}

export default ChartCardGoogle
